export default "__VITE_ASSET__CWvHa9pM__"